import React from 'react'
// import './Login.css';
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { adminLogin } from '../../Redux/userSlice'
import { useNavigate } from 'react-router-dom'
import Loader from '../../components/Loader/Loader'
import { motion } from 'framer-motion'
import { VscRunErrors } from 'react-icons/vsc'
import { FiEye, FiEyeOff } from 'react-icons/fi'

const Login = () => {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const [credentials, setCredentials] = useState({ email: '', password: '' })
  const [shake, setShake] = useState(false)
  const navigate = useNavigate()

  const { authSlice } = selector || {}
  const { error, loading } = authSlice || {}
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (error) {
      setShake(true)
      const timer = setTimeout(() => setShake(false), 500)
      return () => clearTimeout(timer)
    }
  }, [error])

  const handleChange = e => {
    const { name, value } = e.target
    setCredentials({ ...credentials, [name]: value })
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(adminLogin(credentials))
  }

  useEffect(() => {
    if (authSlice?.user) {
      navigate('/app/dashboard')
    }
  }, [authSlice?.user, navigate])

  return (
    <div className='login-container'>
      <div className='shape1'></div>
      <div className='shape2'></div>
      <Loader loading={loading} />

      <motion.div
        animate={shake ? { x: [-10, 10, -10, 10, 0] } : {}}
        transition={{ duration: 0.5 }}
        className='login-form'
      >
        <h2 className='text-xl font-bold'>Welcome To VCNC Admin</h2>
        <form onSubmit={handleSubmit}>
          <div className='input-group'>
            <input
              type='text'
              name='email'
              value={credentials.email}
              onChange={handleChange}
              placeholder='Username'
            />
          </div>

          <div className='input-group relative'>
            <input
              type={showPassword ? 'text' : 'password'}
              name='password'
              value={credentials.password}
              onChange={handleChange}
              placeholder='Password'
              className='w-full pr-10'
            />
            <button
              type='button'
              onClick={() => setShowPassword(!showPassword)}
              className='absolute right-3 top-1/2 transform -translate-y-1 text-gray-600'
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className='error-message'
            >
              <VscRunErrors className='text-lg mr-2' />

              <span>{error}</span>
            </motion.div>
          )}

          <button className='w-full px-4 py-3 text-[0.938rem] bg-[#12192c] text-white font-semibold rounded-lg transition-shadow duration-300 hover:shadow-[0_10px_36px_rgba(0,0,0,0.15)]'>
            Login
          </button>

          <div className='vcnc-container'>
            <p className='vcnc-letter'>V</p>
            <p className='vcnc-letter'>C</p>
            <p className='vcnc-letter'>N</p>
            <p className='vcnc-letter'>C</p>
          </div>
        </form>
      </motion.div>
    </div>
  )
}

export default Login
